import * as React from 'react';
import Input from '../input/Input'
import { Button, Typography } from '@material-ui/core';

class LoginForm extends React.Component<any,{ username: string; password: string }> {
  public mounted : boolean = false;
  constructor(props: any) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };
    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
  }

  public componentDidMount() {
    this.mounted = true;
  }

  public componentWillUnmount(){
    this.mounted = false;
  }

  public setUsername(username: string) {
    if (this.mounted) {
      this.setState({ username });
    }
  }

  public setPassword(password: string) {
    if (this.mounted) {
      this.setState({ password });
    }
  }

  public render() {
    return (
      <div className="loginform">
        <Typography color="primary" align="center" variant="h2">
          Login
        </Typography>
        <Input
          id="username"
          labelName="Username: "
          inputType="text"
          placeholder="Username"
          fullWidth={false}
          parentFunction={this.setUsername}
        />
        <Input
          id="password"
          labelName="Password: "
          inputType="password"
          placeholder="Password"
          fullWidth={false}
          parentFunction={this.setPassword}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            this.props.checkLogin(this.state.username, this.state.password)
          }
          className="Buttons"
        >
          Login
        </Button>
      </div>
    );
  }
}
export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/myaccount/LoginForm.tsx